import MeterQuiz from "@/components/MeterQuiz";
import { CHAOS_METER } from "@/lib/meterQuizzes";

export default function ChaosMeter() {
  return <MeterQuiz config={CHAOS_METER} />;
}
